import { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import DeleteModal from "../../../common/DeleteModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Translate } from "../../../Enums/Tranlate";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import AdminService from "../../../../services/AdminService";
import ConfirmModal from "../../../common/ConfirmModal";

const CardItem = ({ item, index, setShouldUpdate, setItem, setAddModal }) => {
	const [status, setStatus] = useState(null);
	const [statusModal, setStatusModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const adminService = new AdminService();
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		setStatus(!item.isBlocked);
	}, [item]);

	const changeStatusToggle = () => {
		let data = {
			isBlocked: status,
		};
		adminService.toggleStatus(item.id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setStatusModal(false);
				setStatus(!status);
			}
		});
	};

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.username}</td>
			<td>{item?.phone}</td>
			<td>{item?.email}</td>
			<td>
				<Badge
					className="text-capitalize cursor-pointer"
					onClick={() => setStatusModal(true)}
					variant={`${status ? "success" : "danger"} light`}>
					{Translate[lang][status ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<img
						src={editIcon}
						onClick={() => {
							setItem(item);
							setAddModal(true);
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.username}
					deletedItem={item}
					modelService={adminService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
			{statusModal && (
				<ConfirmModal
					open={statusModal}
					body={Translate[lang].change_status_message}
					title={Translate[lang].change_status}
					onCloseModal={() => setStatusModal(false)}
					submitButton={changeStatusToggle}
					button={Translate[lang].submit}
				/>
			)}
		</tr>
	);
};
export default CardItem;
